module.exports = __webpack_public_path__ + "static/img/C4D0034.d95dbe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0034.jpg
// module id = 9ecb
// module chunks = 0